export const entity_language = { 
    entity: { 
        "user": 'Utenti', 
         "user_group": 'Comuni', 
         "user_entity_saved_filters": 'Filtri salvati', 
         "user_entity_preferences": 'Preferenze entità', 
         "log": 'Log di sistema', 
         "ticket": 'Segnalazioni', 
         "ticket_attachments": 'Allegati Segnalazioni', 
         "category": 'Categorie', 
         "subcategory": 'Sottocategorie', 
         "otp_token": 'Token OTP', 
         "app_user_preferences": 'Preferenze Utente APP', 
         "notify_device": 'Dispositivi Utente APP', 
         "app_config": 'Configurazione APP', 
         "notifications": 'Notifiche', 
         "gyv_user_authority": 'Utenti Comuni',
     }, 
    labels: { 
        "user": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "name": 'Nome', 
              "surname": 'Cognome', 
              "username": 'Username', 
              "email": 'Email', 
              "password": 'Password', 
              "phone": 'Telefono', 
              "level": 'Livello',
              "level.options.0": 'admin', 
              "level.options.1": 'Comune', 
              "level.options.2": 'Utente', 
              "level.options.999": 'Guest - Non loggato', 
              "idUserGroup": 'Comune', 
              "idAuthority": 'Comune d\'appartenenza', 
        }, 
        "gyv_user_authority": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "name": 'Nome', 
              "surname": 'Cognome', 
              "username": 'Username', 
              "email": 'Email', 
              "password": 'Password', 
              "phone": 'Telefono', 
              "level": 'Livello',
              "level.options.0": 'admin', 
              "level.options.1": 'Comune', 
              "level.options.2": 'Utente', 
              "level.options.999": 'Guest - Non loggato', 
              "idUserGroup": 'Comune', 
              "idAuthority": 'Comune d\'appartenenza', 
        }, 
        "user_group": { 
              "id": 'Identificativo', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "name": 'Nome', 
              "logo": 'Logo', 
              "notes": 'Note', 
              "expireDate": 'Data di scadenza', 
        }, 
        "user_entity_saved_filters": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "author": 'Utente', 
              "entity": 'Entità', 
              "name": 'Nome', 
              "notes": 'Note', 
              "content": 'Contenuto', 
        }, 
        "user_entity_preferences": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "author": 'Utente', 
              "entity": 'Entità', 
              "content": 'Contenuto', 
        }, 
        "log": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idUser": 'Utente', 
              "entity": 'Entità', 
              "idItem": 'Iditem', 
              "operation": 'Operazione', 
              "operation.options.0_DELETE": '0_delete', 
              "operation.options.1_EDIT": '1_edit', 
              "operation.options.2_ADD": '2_add', 
              "operation.options.3_LOGIN": '3_login', 
              "operation.options.4_LOGOUT": '4_logout', 
              "operation.options.SEND_PUSH_NOTIFICATION": 'SEND_PUSH_NOTIFICATION', 
              "notes": 'Note', 
        }, 
        "ticket": { 
              "id": 'id', 
              "date": 'Data Segnalazione', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idUserGroup": 'Comune d\'appartenenza', 
              "author": 'Utente', 
              "name": 'Nome', 
              "photos": 'Foto', 
              "idCategory": 'Categoria', 
              "idSubcategory": 'Sottocategoria', 
              "address": 'Posizione', 
              "location": 'Indirizzo', 
              "longitude": 'Longitudine',
              "latitude": 'Latitudine',
              "description": 'Descrizione', 
              "status": 'Stato', 
              "status.options.5_OPEN": 'Aperta', 
              "status.options.10_IN_PROGRESS": 'In Gestione', 
              "status.options.15_CLOSED": 'Chiusa', 
              "adminInProgressNotes": 'Autorità - Note di presa in carico', 
              "userInProgressNotes": 'Utente - Note di presa in carico', 
              "inProgressDate": 'Data di presa in carico', 
              "adminClosedNotes": 'Autorità - Note di chiusura', 
              "userClosedNotes": 'Utente - Note di chiusura', 
              "closedDate": 'Data di chiusura', 
        }, 
        "gyv_ticket_open": { 
              "id": 'id', 
              "date": 'Data Segnalazione',
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idUserGroup": 'Comune d\'appartenenza', 
              "author": 'Utente', 
              "name": 'Nome', 
              "photos": 'Foto', 
              "idCategory": 'Categoria', 
              "idSubcategory": 'Sottocategoria', 
              "address": 'Posizione', 
              "location": 'Indirizzo', 
              "longitude": 'Longitudine',
              "latitude": 'Latitudine',
              "description": 'Descrizione', 
              "status": 'Stato', 
              "status.options.5_OPEN": 'Aperta', 
              "status.options.10_IN_PROGRESS": 'In Gestione', 
              "status.options.15_CLOSED": 'Chiusa', 
              "adminInProgressNotes": 'Autorità - Note di presa in carico', 
              "userInProgressNotes": 'Utente - Note di presa in carico', 
              "inProgressDate": 'Data di presa in carico', 
              "adminClosedNotes": 'Autorità - Note di chiusura', 
              "userClosedNotes": 'Utente - Note di chiusura', 
              "closedDate": 'Data di chiusura', 
        }, 
        "gyv_ticket_in_progress": { 
              "id": 'id', 
              "date": 'Data Segnalazione',
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idUserGroup": 'Comune d\'appartenenza', 
              "author": 'Utente', 
              "name": 'Nome', 
              "photos": 'Foto', 
              "idCategory": 'Categoria', 
              "idSubcategory": 'Sottocategoria', 
              "address": 'Posizione', 
              "location": 'Indirizzo', 
              "longitude": 'Longitudine',
              "latitude": 'Latitudine',
              "description": 'Descrizione', 
              "status": 'Stato', 
              "status.options.5_OPEN": 'Aperta', 
              "status.options.10_IN_PROGRESS": 'In Gestione', 
              "status.options.15_CLOSED": 'Chiusa', 
              "adminInProgressNotes": 'Autorità - Note di presa in carico', 
              "userInProgressNotes": 'Utente - Note di presa in carico', 
              "inProgressDate": 'Data di presa in carico', 
              "adminClosedNotes": 'Autorità - Note di chiusura', 
              "userClosedNotes": 'Utente - Note di chiusura', 
              "closedDate": 'Data di chiusura', 
        }, 
        "gyv_ticket_closed": { 
              "id": 'id', 
              "date": 'Data Segnalazione',
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idUserGroup": 'Comune d\'appartenenza', 
              "author": 'Utente', 
              "name": 'Nome', 
              "photos": 'Foto', 
              "idCategory": 'Categoria', 
              "idSubcategory": 'Sottocategoria', 
              "address": 'Posizione', 
              "location": 'Indirizzo', 
              "longitude": 'Longitudine',
              "latitude": 'Latitudine',
              "description": 'Descrizione', 
              "status": 'Stato', 
              "status.options.5_OPEN": 'Aperta', 
              "status.options.10_IN_PROGRESS": 'In Gestione', 
              "status.options.15_CLOSED": 'Chiusa', 
              "adminInProgressNotes": 'Autorità - Note di presa in carico', 
              "userInProgressNotes": 'Utente - Note di presa in carico', 
              "inProgressDate": 'Data di presa in carico', 
              "adminClosedNotes": 'Autorità - Note di chiusura', 
              "userClosedNotes": 'Utente - Note di chiusura', 
              "closedDate": 'Data di chiusura', 
        }, 
        "ticket_attachments": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idTicket": 'Segnalazione', 
              "file": 'Allegato', 
        }, 
        "category": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "title": 'Titolo', 
        }, 
        "subcategory": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idCategory": 'Categoria', 
              "title": 'Titolo', 
        }, 
        "otp_token": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "token": 'Token', 
        }, 
        "app_user_preferences": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "author": 'Utente', 
              "option": 'Chiave', 
              "value": 'Valore', 
        }, 
        "notify_device": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "author": 'Utente', 
              "token": 'Token', 
        }, 
        "app_config": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "nameConfig": 'Chiave', 
              "valueConfig": 'Valore', 
        }, 
        "notifications": { 
              "id": 'id', 
              "date": 'Data', 
              "lastUpdate": 'Ultimo aggiornamento', 
              "deleted": 'Eliminato', 
              "idUser": 'Utente', 
              "title": 'Titolo', 
              "description": 'Descrizione', 
              "isRead": 'Letta', 
        }, 
   } 
};                    